module.exports = __webpack_public_path__ + "img/time-circle-fill.022fa4b5.svg";